import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { ModalContext } from './ModalContext'
import { ModalMetadata } from './types'

@Component
export class ModalManagerMixin extends Vue {
  openModal(modalId: string, metadata?: Partial<Omit<ModalMetadata, 'active'>>): void {
    ModalContext.instance.setMetadata(modalId, { ...metadata, active: true })
  }

  closeModal(modalId: string): void {
    ModalContext.instance.setMetadata(modalId, { active: false })
  }

  getModalMetadata(modalId: string): Partial<ModalMetadata> | undefined {
    return ModalContext.instance.getMetadata(modalId)
  }
}

export default ModalManagerMixin
